/* @flow */
import * as React from 'react';
import AuthActions from 'auth/AuthActions';
import { FormattedMessage } from 'react-intl';
import Glyph from 'components/Glyph.jsx';
import LayerTrigger from 'components/LayerTrigger.jsx';
import LinkConstants from 'constants/LinkConstants';
import MenuItem from 'components/MenuItem.jsx';
import ModalMenuItem from 'components/ModalMenuItem.jsx';
import NavigationMenu from 'components/NavigationMenu.jsx';
import InviteModal from 'users/components/InviteModal.jsx';
import SupportDialog from 'support/components/SupportDialog.jsx';
import TextAppLinkDialog from 'user/components/TextAppLinkDialog.jsx';

type Props = {
  showRCE?: boolean,
  children?: React.Element<any>,
};

class UserNavigationMenu extends React.Component<Props> {
  signOut = () => AuthActions.signOut();

  render() {
    const { children, showRCE } = this.props;

    const menu = (
      <NavigationMenu>
        <MenuItem to="/settings" eventElementName="Navigation-account" color="thunder">
          <Glyph name="avatar" size="large" />
          <FormattedMessage id="navigation.settings" defaultMessage="Account" />
        </MenuItem>
        {showRCE && (
          <MenuItem
            href={LinkConstants.COMMUNITY}
            target="_blank"
            eventElementName="Navigation-rce"
            color="thunder">
            <Glyph name="apple" size="large" />
            <FormattedMessage id="navigation.rce" defaultMessage="Connected Educator" />
          </MenuItem>
        )}
        <ModalMenuItem modal={<SupportDialog />}>
          <Glyph name="help" size="large" />
          <FormattedMessage id="navigation.getTheApp" defaultMessage="Help center" />
        </ModalMenuItem>
        <ModalMenuItem modal={<InviteModal />}>
          <Glyph name="heart" size="large" />
          <FormattedMessage id="navigation.getTheApp" defaultMessage="Share Remind" />
        </ModalMenuItem>
        <ModalMenuItem modal={<TextAppLinkDialog />}>
          <Glyph name="mobile" size="large" />
          <FormattedMessage id="navigation.getTheApp" defaultMessage="Get the Remind app" />
        </ModalMenuItem>
        <MenuItem onClick={this.signOut} eventElementName="Navigation-logOut" color="thunder">
          <Glyph name="sign-out" size="large" />
          <FormattedMessage id="navigation.logout" defaultMessage="Log out" />
        </MenuItem>
      </NavigationMenu>
    );

    return (
      <LayerTrigger layer={menu} placement="bottom" trigger="click">
        {children}
      </LayerTrigger>
    );
  }
}

export default UserNavigationMenu;
